"use client";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVertical, Pencil, Ban } from "lucide-react";
import { formatPaise } from "../../../utils/billingFormat";

const PlanList = ({ plans, onEdit, onDisable }) => {
  if (plans.length === 0) {
    return <div className="py-16 text-center text-gray-400 text-sm">No plans yet — create one to get started.</div>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Price</TableHead>
          <TableHead>Duration</TableHead>
          <TableHead>Max Users</TableHead>
          <TableHead>GST</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {plans.map((plan) => (
          <TableRow key={plan._id}>
            <TableCell>
              <div className="font-medium">{plan.name}</div>
              {plan.description && <div className="text-xs text-gray-500">{plan.description}</div>}
            </TableCell>
            <TableCell>{formatPaise(plan.baseAmount)}</TableCell>
            <TableCell>{plan.durationMonths} months</TableCell>
            <TableCell>{plan.maxUsers}</TableCell>
            <TableCell>{plan.gstRate}%</TableCell>
            <TableCell>
              <Badge variant={plan.isActive ? "default" : "secondary"}>{plan.isActive ? "Active" : "Disabled"}</Badge>
            </TableCell>
            <TableCell className="text-right">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <MoreVertical className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={() => onEdit(plan)}>
                    <Pencil className="w-4 h-4 mr-2" /> Edit
                  </DropdownMenuItem>
                  {plan.isActive && (
                    <DropdownMenuItem onClick={() => onDisable(plan)} className="text-red-600">
                      <Ban className="w-4 h-4 mr-2" /> Disable
                    </DropdownMenuItem>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PlanList;
